import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { EGiftPackagingAllowedType } from '@notino/shared/__generated__/globalSPATypes';

import { ICurrency } from '../../../../App/model';
import messages from '../../../messages';
import { variantFragment_campaignConfig } from '../../../queries/__generated__/variantFragment';
import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';
import { GiftBase } from '../ProductGifts/GiftBase';
import { Description } from '../ProductGifts/styled';

interface IFreeGiftPackagingProps {
  campaign: variantFragment_campaignConfig;
  currency: ICurrency;
  brand: string;
}

export const FreeGiftPackaging: React.FC<IFreeGiftPackagingProps> = React.memo(
  ({ campaign: { allowed, price, groupName }, currency, brand }) => {
    const newDesign = useNewPdDesignEnabled();

    if (
      allowed === EGiftPackagingAllowedType.None ||
      groupName !== 'GiftPackaging'
    ) {
      return null;
    }

    return (
      <GiftBase
        containerId="pdFreeGiftPackaging"
        isGiftImage={true}
        titleMessage={messages.freeGiftPackagingTitle}
        imageUrl={'darkove-krabice/2800018346842_01_small-o.jpg'}
        imageMessage={messages.freeGiftPackagingProductInfo}
      >
        <Description newDesign={newDesign}>
          {allowed === EGiftPackagingAllowedType.Product ? (
            <FormattedMessage
              values={{ currency: currency.symbol, brand, price }}
              {...messages.freeGiftPackagingProductInfo}
            />
          ) : (
            <FormattedMessage
              values={{ currency: currency.symbol, brand, price }}
              {...messages.freeGiftPackagingBrandInfo}
            />
          )}
        </Description>
      </GiftBase>
    );
  }
);
